/* Maison Mata: one-time editorial text reveals. No cursor or loading overlay. */
(() => {
  if (window.__mmMotionInstalled) return;
  window.__mmMotionInstalled = true;
  function localizeAtelierLinks() {
    const language=(document.documentElement.lang||'en').toLowerCase();
    const prefixes={'pt-br':'pt','zh-cn':'zh'};
    const locale=prefixes[language]||language;
    const root=locale==='en'?'':'/'+locale;
    document.querySelectorAll('a[href*="maison-mata-a204-recette.probealdavid.workers.dev"]').forEach(link=>{
      const url=new URL(link.href);
      if(url.hostname!=='maison-mata-a204-recette.probealdavid.workers.dev'||!['/','/index.html','/signature','/signature/','/signature/index.html'].includes(url.pathname))return;
      const target=new URL(root+'/pages/the-atelier',location.origin);
      for(const key of ['frame','autostart'])if(url.searchParams.has(key))target.searchParams.set(key,url.searchParams.get(key));
      if(url.pathname.startsWith('/signature'))target.searchParams.set('line','signature');
      link.href=target.href;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',localizeAtelierLinks,{once:true});else localizeAtelierLinks();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const lang = document.documentElement.lang || 'en';
  const joined = /^(ar|fa|ur|hi|bn|th)(-|$)/.test(lang);
  const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(lang, {granularity:'grapheme'}) : null;
  const active = new Map();
  const excluded = 'button,summary,form,dialog,[role="dialog"],[role="alert"],[aria-live],product-recommendations,quick-add-modal,modal-dialog,.card-wrapper,.card,.collection-card,.journal-card,.facets,.facet-filters,.product-count,.cart-items,.totals,.shopify-app-block,.visually-hidden,.hidden,[data-mm-no-reveal]';
  const storeTitles = '.mm-stores__feature-info h2,.mm-stores__card h3,.mm-visit__store h3,.mm-visit__future h4';
  const smallText = '.mmh__eyebrow,.mmfb__eyebrow,.mm-visit__eyebrow,.mm-stores__list-heading .mm-stores__eyebrow,.mw-eyebrow,.mf-eyebrow,.rich-text__caption,.image-with-text__text--caption,.mm-lens__kicker';
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      animate(entry.target);
    }
  }, {threshold:.15});
  function eligible(el) {
    const text = el.textContent.trim();
    if (!text || text.length > 160 || el.closest(excluded) || el.querySelector('a,button,input,svg,img,script,style')) return false;
    if (el.matches('[aria-hidden="true"],.visually-hidden')) return false;
    // Hidden boutique panels are observed now and play only when selected.
    if (el.matches(storeTitles)) return true;
    const box=el.getBoundingClientRect(),style=getComputedStyle(el);
    return box.width>2 && box.height>2 && style.visibility!=='hidden' && style.display!=='none';
  }
  function choose(list,limit) {
    return list.length<=limit ? list : Array.from({length:limit},(_,i)=>list[Math.round(i*(list.length-1)/(limit-1))]);
  }
  function scan() {
    const main=document.querySelector('main');
    if (!main || reduced.matches) return;
    const collect=s=>Array.from(main.querySelectorAll(s)).filter(eligible);
    const primary=collect('h1,[data-mm-letter-reveal],'+storeTitles);
    const secondary=choose(collect('h2,.mmh__title').filter(el=>!primary.includes(el)),6);
    const small=choose(collect(smallText).filter(el=>el.textContent.trim().length<=80),3);
    for (const el of new Set([...primary,...secondary,...small])) {
      if (el.dataset.mmRevealBound) continue;
      el.dataset.mmRevealBound='true';
      observer.observe(el);
    }
  }
  function animate(el) {
    el.dataset.mmRevealed='true';
    if (reduced.matches || !el.isConnected) return;
    const original=Array.from(el.childNodes),visual=document.createElement('span'),accessible=document.createElement('span');
    visual.className='mm-reveal-visual';visual.setAttribute('aria-hidden','true');
    accessible.className='visually-hidden';accessible.textContent=el.textContent.trim();
    for (const node of original) visual.append(node.cloneNode(true));
    let index=0;
    function wrap(parent) {
      for (const node of Array.from(parent.childNodes)) {
        if (node.nodeType===3) {
          const fragment=document.createDocumentFragment();
          for (const word of node.textContent.split(/(\s+)/)) {
            if (!word) continue;
            if (/^\s+$/.test(word)) { fragment.append(document.createTextNode(word));continue; }
            const wordEl=document.createElement('span');wordEl.className='mm-reveal-word';
            const chars=joined?[word]:segmenter?Array.from(segmenter.segment(word),s=>s.segment):Array.from(word);
            for (const char of chars) {
              const clip=document.createElement('span'),glyph=document.createElement('span');
              clip.className='mm-reveal-clip';glyph.className='mm-reveal-glyph';glyph.textContent=char;
              glyph.dataset.delay=String(Math.min(index++*14,360));clip.append(glyph);wordEl.append(clip);
            }
            fragment.append(wordEl);
          }
          node.replaceWith(fragment);
        } else if (node.nodeType===1 && !node.matches('.visually-hidden,[aria-hidden="true"]')) wrap(node);
      }
    }
    wrap(visual);el.replaceChildren(accessible,visual);
    const restore=()=>{ if(el.contains(visual)) el.replaceChildren(...original);active.delete(el); };
    // Never trade readable content or the original line breaks for an effect.
    if(el.scrollWidth>el.clientWidth+2 && el.clientWidth>0){restore();return;}
    const animations=[];
    active.set(el,{restore,animations});
    try {
      for(const glyph of visual.querySelectorAll('.mm-reveal-glyph')) animations.push(glyph.animate([
        {transform:'translateY(105%)',opacity:.3},{transform:'translateY(0)',opacity:1}
      ],{duration:600,delay:Number(glyph.dataset.delay),easing:'cubic-bezier(.2,.7,.2,1)',fill:'both'}));
      Promise.allSettled(animations.map(a=>a.finished)).then(restore);
    } catch (_) { for(const a of animations)a.cancel();restore(); }
  }
  reduced.addEventListener('change',()=>{
    if(!reduced.matches)return;
    observer.disconnect();
    for(const {animations,restore} of Array.from(active.values())){animations.forEach(a=>a.cancel());restore();}
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('[data-mm-reveal-bound]').forEach(el=>{observer.unobserve(el);active.get(el)?.restore();});
  });
})();
